import { render, staticRenderFns } from "./main_default.vue?vue&type=template&id=60853b17&"
import script from "./main_default.vue?vue&type=script&lang=js&"
export * from "./main_default.vue?vue&type=script&lang=js&"
import style0 from "./main_default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports